import React from 'react'

const loanPage = () => {
    return (
        <div>
            <div style={{height: "100px", width: "100%", textAlign: "center", marginTop: "120px"}}>
            Da oggi puoi richiedere un finanziamento finalizzato all'acquisto di una delle 
            nostre vetture in pochissimi click.

            <br/>
            <br/>

            Segui la procedura sottostante per caricare in autonomia la richiesta di finanziamento 
            e ricevere l'esito in tempo reale!
                 
            </div>
            {/* <iframe title="agos" src="https://finanziamenti.agosweb.it/cics/cwba/NPJ1O001/cduser=VIDMJ2L&cdconv=22224832&cdcval=e&imbene=0,00&cdfnz=nvi&cnvritiro=22224832&cdazio=IN&inpp=P&dtrich=20170726&cdsource=1" width="100%" height="1000"></iframe> */}
            {/* <!-- Elfsight Instagram Feed | Untitled Instagram Feed --> */}
            {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.2.10/iframeResizer.min.js"></script> */}
            {/* <iframe title="foo" src="https://de7c1015385d46318b64cac823210ff1.elf.site" style={{border:"none", width:"100%"}}></iframe> */}

        </div>
    );
}

export default loanPage;